import { Dashboard, Pages } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { Home } from "./Home";
import { appType, currentFeatures } from "../../configs/Settings";
import VetProfessionalDashboard from "@/fluxvet/components/VetProfessionalDashboard";
import { useSessionContext } from "@/contexts/SessionContext";
import FluxVetDashboard from "@/fluxvet/pages/dashboard/FluxVetDashboard";

export function useHome() {
  const { access } = useSessionContext();
  const configs: IFeatures = {
    initial: true,
    active: currentFeatures.home,
    path: "/home",
    text: currentFeatures.defaultApp ? "Painel de controle" : "Dashboard",
    icon: currentFeatures.defaultApp ? Pages : Dashboard,

    sideMenu: true,
    sideMenuIndex: 0,

    component: () =>
      !currentFeatures.defaultApp && access.type === "patient" ? (
        <FluxVetDashboard />
      ) : (
        <Home />
      ),
  };

  return configs;
}
